import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import {
  Typography,
  Box,
  CircularProgress,
  Paper,
  TextField,
  Rating,
} from "@mui/material";
import { styled } from "@mui/material/styles";

// TODO: uprav cestu podle toho, kde máš assety
// import bitwiseGlitch from "../assets/bitwiseGlitch.png";

const StyledTextField = styled(TextField)({
  "& label": {
    color: "rgba(242, 237, 228, 0.55)",
    fontFamily: "'Cactus Classical Serif', serif",
  },
  "& label.Mui-focused": {
    color: "rgba(242, 237, 228, 0.7)",
  },
  "& .MuiOutlinedInput-root": {
    color: "rgba(242, 237, 228, 0.9)",
    fontFamily: "'Cactus Classical Serif', serif",
    background: "rgba(0,0,0,0.28)",
    borderRadius: "16px",
    "& fieldset": {
      borderColor: "rgba(242,237,228,0.14)",
    },
    "&:hover fieldset": {
      borderColor: "rgba(242,237,228,0.22)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "rgba(242,237,228,0.28)",
    },
  },
});

const panelSoft3DSx = {
  border: "1px solid rgba(242, 237, 228, 0.12)",
  borderRadius: "16px",
  background: "rgba(0,0,0,0.35)",
  boxShadow: "0px 4px 50px 3px rgba(242, 237, 228, 0.06)",
};

const ReviewForm = () => {
  const [tokenValid, setTokenValid] = useState(false);
  const [loading, setLoading] = useState(true);
  const [submitted, setSubmitted] = useState(false);
  const [submitError, setSubmitError] = useState(null);

  const [formData, setFormData] = useState({
    overall: 3,
    comment: "",
  });

  const token = useMemo(
    () => new URLSearchParams(window.location.search).get("reviewToken"),
    []
  );

  useEffect(() => {
    if (submitted) {
      const url = new URL(window.location.href);
      url.searchParams.delete("reviewToken");
      window.history.replaceState({}, "", url);
    }
  }, [submitted]);

  useEffect(() => {
    const validateToken = async () => {
      try {
        const res = await axios.get(`/api/reviews/validate-token?token=${token}`);
        if (res.data.valid) setTokenValid(true);
      } catch (err) {
        console.error("Token není platný:", err);
        setTokenValid(false);
      } finally {
        setLoading(false);
      }
    };

    validateToken();
  }, [token]);

  const handleChange = (event, value) => {
    if (value !== null) setFormData((prev) => ({ ...prev, overall: value }));
  };

  const handleTextChange = (e) => {
    setFormData((prev) => ({ ...prev, comment: e.target.value }));
  };

  const handleSubmit = async () => {
    try {
      setSubmitError(null);
      await axios.post("/api/reviews/submit", {
        token,
        story: formData.overall,
        puzzles: formData.overall,
        difficulty: formData.overall,
        route: formData.overall,
        overall: formData.overall,
        comment: formData.comment,
      });
      setSubmitted(true);
      window.reviewSubmitted = true;
    } catch (err) {
      console.error("Chyba při odeslání recenze:", err);
      setSubmitError("Nepodařilo se odeslat recenzi. Zkuste to prosím znovu.");
    }
  };

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: "100dvh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#0E0E0E",
          color: "#F2EDE4",
          p: 2,
        }}
      >
        <Box sx={{ textAlign: "center" }}>
          <CircularProgress />
          <Typography
            sx={{
              mt: 2,
              color: "rgba(242,237,228,0.7)",
              fontFamily: "'Cactus Classical Serif', serif",
            }}
          >
            Ověřujeme odkaz…
          </Typography>
        </Box>
      </Box>
    );
  }

  if (!tokenValid) {
    return (
      <Box
        sx={{
          minHeight: "100dvh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#0E0E0E",
          p: 2,
        }}
      >
        <Paper elevation={0} sx={{ ...panelSoft3DSx, p: 3, maxWidth: 520, width: "100%" }}>
          <Typography
            sx={{
              fontFamily: "'Cinzel', serif",
              textTransform: "uppercase",
              letterSpacing: "0.1em",
              fontSize: 16,
              color: "#F2EDE4",
              textAlign: "center",
              mb: 1,
            }}
          >
            Odkaz není platný
          </Typography>
          <Typography
            sx={{
              color: "rgba(242,237,228,0.65)",
              fontFamily: "'Cactus Classical Serif', serif",
              textAlign: "center",
              lineHeight: 1.7,
            }}
          >
            Odkaz je neplatný nebo již použitý.
          </Typography>
        </Paper>
      </Box>
    );
  }

  if (submitted) {
    return (
      <Box
        sx={{
          minHeight: "100dvh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#0E0E0E",
          p: 2,
        }}
      >
        <Paper elevation={0} sx={{ ...panelSoft3DSx, p: 3, maxWidth: 520, width: "100%" }}>
          <Typography
            sx={{
              fontFamily: "'Cinzel', serif",
              textTransform: "uppercase",
              letterSpacing: "0.1em",
              fontSize: 16,
              color: "#F2EDE4",
              textAlign: "center",
              mb: 1,
            }}
          >
            Děkujeme
          </Typography>
          <Typography
            sx={{
              color: "rgba(242,237,228,0.75)",
              fontFamily: "'Cactus Classical Serif', serif",
              textAlign: "center",
              lineHeight: 1.7,
            }}
          >
            Recenze byla odeslána.
          </Typography>
          {/* Close window button */}
<Box sx={{ mt: 2.4, display: "flex", justifyContent: "center" }}>
  <Box
   onClick={() => {
  window.open('', '_self');
  window.close();
}}
    sx={{
      ...panelSoft3DSx,
      width: "min(420px, 90%)",
      p: 1.6,
      textAlign: "center",
      cursor: "pointer",
      userSelect: "none",
      transition: "all 0.25s ease",
      border: "1px solid rgba(242,237,228,0.10)",
      background: "rgba(0,0,0,0.25)",
      "&:hover": {
        border: "1px solid rgba(242,237,228,0.18)",
        background: "rgba(0,0,0,0.35)",
      },
      "&:active": {
        transform: "translateY(1px)",
      },
    }}
  >
    <Typography
      sx={{
        fontFamily: "'Cinzel', serif",
        textTransform: "uppercase",
        letterSpacing: "0.1em",
        fontSize: 12.5,
        color: "rgba(242,237,228,0.8)",
      }}
    >
      Zavřít okno
    </Typography>
  </Box>
</Box>
        </Paper>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: "100dvh",
        backgroundColor: "#0E0E0E",
        position: "relative",
        isolation: "isolate",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        p: { xs: 2, sm: 3 },
        pt: { xs: 4, sm: 6 },
      }}
    >
      {/* glitch overlay (volitelné) */}
      {/* <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundImage: `url(${bitwiseGlitch})`,
          backgroundRepeat: "repeat",
          backgroundSize: "auto",
          mixBlendMode: "soft-light",
          opacity: 0.22,
          pointerEvents: "none",
          zIndex: 0,
        }}
      /> */}

      <Paper
        elevation={0}
        sx={{
          ...panelSoft3DSx,
          width: "min(720px, 100%)",
          p: { xs: 2.2, sm: 3 },
          zIndex: 1,
        }}
      >
        {/* Title */}
        <Typography
          sx={{
            fontFamily: "'Cinzel', serif",
            textTransform: "uppercase",
            letterSpacing: "0.1em",
            fontWeight: 600,
            fontSize: "clamp(18px, 2.4vw, 26px)",
            textAlign: "center",
            color: "#F2EDE4",
            textShadow: "0 2px 0 rgba(0,0,0,0.70), 0 0 14px rgba(242,237,228,0.12)",
            mb: 0.8,
          }}
        >
          Ohodnoťte hru
        </Typography>

        <Typography
          sx={{
            fontFamily: "'Cinzel', serif",
            textTransform: "uppercase",
            letterSpacing: "0.25em",
            fontSize: 11,
            textAlign: "center",
            color: "rgba(242,237,228,0.55)",
          }}
        >
          Break The Mystery
        </Typography>

        <Box
          sx={{
            height: "1px",
            width: "100%",
            background:
              "linear-gradient(90deg, rgba(242,237,228,0.7) 0%, rgba(242,237,228,0.14) 50%, rgba(242,237,228,0.7) 100%)",
            mt: 1.8,
            mb: 2.6,
            opacity: 0.9,
          }}
        />

        {/* Ratings */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.6 }}>
          {[{ label: "Celkové hodnocení", field: "overall" }].map(({ label, field }) => (
            <Box key={field} sx={{ ...panelSoft3DSx, p: 1.6 }}>
              <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, alignItems: "center", justifyContent: "space-between", gap: { xs: 1.2, sm: 2 }, textAlign: { xs: "center", sm: "left" } }}>
                <Typography
                  sx={{
                    color: "rgba(242,237,228,0.86)",
                    fontFamily: "'Cactus Classical Serif', serif",
                    fontSize: 14.5,
                  }}
                >
                  {label}
                </Typography>

                <Rating
                  name={field}
                  value={formData[field]}
                  onChange={handleChange}
                  max={5}
                  
                sx={{
                    // ZMĚNA ZDE: Responzivní velikost hvězdiček
                    fontSize: { xs: "2rem", sm: "2.35rem" }, 
                    "& .MuiRating-iconEmpty": { color: "rgba(242,237,228,0.22)" },
                    "& .MuiRating-iconFilled": { color: "rgba(242,237,228,0.9)" },
                    "& .MuiRating-iconHover": { color: "rgba(242,237,228,1)" },
                    // Zajištění, aby rating nikdy neroztáhl rodičovský kontejner
                    maxWidth: "100%", 
                  }}
                />
              </Box>
            </Box>
          ))}
        </Box>

        {/* Comment */}
        <Box sx={{ mt: 2.2 }}>
          <StyledTextField
            fullWidth
            label="Komentář (volitelný)"
            multiline
            rows={4}
            value={formData.comment}
            onChange={handleTextChange}
            variant="outlined"
          />
        </Box>

        {submitError && (
          <Typography
            sx={{
              mt: 1.6,
              color: "rgba(255,130,130,0.85)",
              fontFamily: "'Cactus Classical Serif', serif",
              textAlign: "center",
            }}
          >
            {submitError}
          </Typography>
        )}

        {/* Submit button – panel style */}
        <Box sx={{ mt: 2.4, display: "flex", justifyContent: "center" }}>
          <Box
            onClick={handleSubmit}
            sx={{
              ...panelSoft3DSx,
              width: "min(520px, 92%)",
              p: 2,
              textAlign: "center",
              cursor: "pointer",
              userSelect: "none",
              transition: "all 0.25s ease",
              "&:hover": {
                border: "1px solid rgba(242,237,228,0.18)",
                background: "rgba(0,0,0,0.45)",
              },
              "&:active": {
                transform: "translateY(1px)",
              },
            }}
          >
            <Typography
              sx={{
                fontFamily: "'Cinzel', serif",
                textTransform: "uppercase",
                letterSpacing: "0.1em",
                fontSize: 13,
                color: "#F2EDE4",
              }}
            >
              Odeslat recenzi
            </Typography>
          </Box>
        </Box>

        {/* small note */}
        <Typography
          sx={{
            mt: 2.2,
            color: "rgba(242,237,228,0.45)",
            fontFamily: "'Cactus Classical Serif', serif",
            fontSize: 12.5,
            textAlign: "center",
            lineHeight: 1.6,
          }}
        >
          Děkujeme. Vaše zpětná vazba pomáhá zlepšovat další případy.
        </Typography>
        
      </Paper>
    </Box>
  );
};

export default ReviewForm;
